import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-folder",
  "use": "icon-folder-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-folder\"><path d=\"M13 4H8.5L7 2H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2M3 3h3.5l.8 1H2c0-.6.4-1 1-1m11 9c0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1V5h11c.6 0 1 .4 1 1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol